import axios from "axios";
import store from "../store/index.ts";
import estados from "./estados.json";
import router from "../router";

export default {
  showMessage(title, message, subMessage, ok, cancel) {
    store.commit("showShowMessage", {
      title,
      message,
      subMessage: subMessage || "",
      buttons: {
        ok: {
          label: (ok && ok.label) || "OK",
          visible: !!ok || true,
          onClick: function () {
            ok && ok.onClick && ok.onClick();
          },
        },
        cancel: {
          label: (cancel && cancel.label) || "Cancelar",
          visible: !!cancel || false,
          onClick: function () {
            cancel && cancel.onClick && cancel.onClick();
          },
        },
      },
    });
  },

  // Authetication ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async login(cnpj, senha, resolve, reject) {
    try {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_URL || window.location.origin}/login`,
        { cnpj, senha }
      );
      if (data) resolve(data);
    } catch (error) {
      reject(error);
    }
  },

  // Cidades e Estados ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getEstados() {
    return estados;
  },

  async getCidades(estado, resolve) {
    try {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/cidades?estado=${estado}`,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        this.showMessage(
          "Mensagem",
          "Erro ao carregar cidades",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  // Clientes //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getClientes(resolve) {
    try {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/clientes`,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        this.showMessage(
          "Mensagem",
          "Erro ao carregar clientes",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  async buscarCliente(busca, resolve) {
    try {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/clientes/buscar?busca=${busca}`,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        this.showMessage(
          "Mensagem",
          "Erro ao buscar clientes",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  async postCliente(params, resolve) {
    try {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/clientes`,
        params,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        const subMessage = error.response &&
          error.response.data &&
          error.response.data.errors.join("\n") || null;
        this.showMessage(
          "Mensagem",
          "Erro ao salvar os dados do cliente",
          subMessage || (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  async patchCliente(params, resolve) {
    try {
      const { data } = await axios.patch(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/clientes/${params._id}`,
        params,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        this.showMessage(
          "Mensagem",
          "Erro ao salvar os dados do cliente",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  async deleteCliente(params, resolve) {
    try {
      const { data } = await axios.delete(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/clientes/${params._id}`,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        this.showMessage(
          "Mensagem",
          "Erro ao deletar o cliente",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  // Produtos //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getProdutos(resolve) {
    try {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/produtos`,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        this.showMessage(
          "Mensagem",
          "Erro ao carregar produtos",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  async buscarProduto(busca, resolve) {
    try {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/produtos/buscar?busca=${busca}`,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        this.showMessage(
          "Mensagem",
          "Erro ao buscar produtos",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  // Pedido //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getPedidos(resolve) {
    try {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/pedidos`,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        this.showMessage(
          "Mensagem",
          "Erro ao carregar pedidos",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  async postPedido(pedido, resolve) {
    try {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/pedidos`,
        pedido,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        const subMessage = error.response &&
          error.response.data &&
          error.response.data.errors.join("\n") || null;
        this.showMessage(
          "Mensagem",
          "Erro ao salvar os dados do pedido",
          subMessage || (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  async patchPedido(pedido, resolve) {
    try {
      const { data } = await axios.patch(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/pedidos/${pedido._id}`,
        pedido,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        this.showMessage(
          "Mensagem",
          "Erro ao atualizar os dados do pedido",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },

  async cancelarPedido(pedido, resolve) {
    try {
      const { data } = await axios.patch(
        `${process.env.VUE_APP_API_URL || window.location.origin}/api/pedidos/${pedido._id}/cancelar`,
        pedido,
        {
          headers: {
            id: store.state.loginData.id,
            senha: store.state.loginData.senha
          }
        });

      if (data) resolve(data);
    } catch (error) {
      if (error.response.status === 401) {
        router.push("/login", () => { });
      } else {
        this.showMessage(
          "Mensagem",
          "Erro ao cancelar os dados do pedido",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message,
          true
        );
      }
    }
  },
};
